<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100">
        <div class="custom_container">
            <div class="search-container ryno-investigation">
                <div class="top-actions">
                    <div class="top-actions-left">
                        <button class="back-button" (click)="onBackButtonClick()"><i class="fas fa-arrow-left"></i> Back</button>
                        <div class="view-tabs" *ngIf="isOsintAiAnalysisEnabled">
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'results'" (click)="setViewTab('results')"><i class="fas fa-list"></i> Results</button>
                            <button type="button" class="view-tab" [class.active]="activeViewTab === 'ai-analysis'" (click)="setViewTab('ai-analysis')" *ngIf="isOsintAiAnalysisEnabled"><i class="fas fa-wand-magic-sparkles"></i> AI OSINT Analysis</button>
                        </div>
                    </div>
                    <div class="top-actions-right" *ngIf="!isLoadingResults && inv">
                        <div class="dropdown">
                            <button
                                class="export-button dropdown-toggle"
                                type="button"
                                id="walletExportDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                [disabled]="exportBusy"
                            >
                                <i class="fas" [ngClass]="exportBusy ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                                {{ exportingFormat === 'pdf' ? 'Generating PDF...' : exportingFormat === 'zip' ? 'Building ZIP...' : 'Export Report' }}
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="walletExportDropdown">
                                <li>
                                    <a class="dropdown-item export-item" (click)="onExportOptionClick('pdf')">Export as PDF</a>
                                </li>
                                <li>
                                    <a
                                        class="dropdown-item export-item"
                                        (click)="onExportOptionClick('zip')"
                                        title="ZIP containing the PDF report and a text file with its MD5 &amp; SHA-256 hashes"
                                    >Export as ZIP</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <div
                    *ngIf="!isLoadingResults && !inv && activeViewTab === 'results'"
                    class="loading-container text-center my-3"
                >
                    <p class="mt-2 text-main-color">No investigation results found for this wallet.</p>
                </div>

                <ng-container *ngIf="!isLoadingResults && inv && activeViewTab === 'results'">
                    <!-- Header -->
                    <section class="inv-header">
                        <div class="inv-header-top">
                            <div class="inv-header-left">
                                <h2 class="inv-title">
                                    <i class="fas fa-shield-halved"></i>
                                    Investigation Results
                                    <span class="chain-badge">
                                        <span class="btc-dot" aria-hidden="true"></span>
                                        {{ inv.chainName }} ({{ inv.symbol }})
                                    </span>
                                    <span class="entity-badge" *ngIf="inv.entityLabel?.name">
                                        <i class="fas fa-building"></i>
                                        {{ inv.entityLabel.name }} · {{ inv.entityLabel.type }}
                                    </span>
                                </h2>
                                <div class="inv-address-row">
                                    <p class="inv-address">{{ displayAddress }}</p>
                                    <button type="button" class="icon-btn" (click)="copyText(displayAddress)" title="Copy address" aria-label="Copy address">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="inv-header-actions">
                                <div class="risk-badge" [ngClass]="riskTone">
                                    <i class="fas" [ngClass]="riskIcon"></i>
                                    <div>
                                        <div class="risk-score">{{ inv.riskScore }}/100</div>
                                        <div class="risk-level">{{ inv.riskLevel }} Risk</div>
                                    </div>
                                    <span class="info-hint-wrap risk-info">
                                        <button
                                            type="button"
                                            class="info-hint"
                                            (click)="toggleInfoHint('risk', $event)"
                                            aria-label="What does this mean?"
                                            title="What does this mean?"
                                        >?</button>
                                        <div
                                            class="info-popover"
                                            *ngIf="activeInfoHint === 'risk'"
                                            [class.place-top]="infoHintPlacement === 'top'"
                                            [class.place-bottom]="infoHintPlacement === 'bottom'"
                                            [ngStyle]="infoHintStyle"
                                            (click)="$event.stopPropagation()"
                                        >
                                            <div class="info-popover-block">
                                                <p class="info-popover-label">In simple words</p>
                                                <p class="info-popover-text">{{ kpiHints.risk.en }}</p>
                                            </div>
                                            <div class="info-popover-block bordered">
                                                <p class="info-popover-label">आसान हिंदी में</p>
                                                <p class="info-popover-text" lang="hi">{{ kpiHints.risk.hi }}</p>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="source-row">
                            <span class="src-pill ok" *ngFor="let src of inv.dataSources">✓ {{ src }}</span>
                            <span class="src-pill price" *ngIf="inv.usd?.price">
                                <span class="btc-dot sm"></span>
                                {{ inv.symbol }} &#64; {{ fiatPair(inv.usd?.price, inv.inr?.price) }}
                            </span>
                            <span class="src-pill err" *ngFor="let err of inv.errors">✗ {{ err }}</span>
                        </div>
                        <div
                            class="inv-header-footer"
                            *ngIf="(displayNote || (needsDeepScan && deepScanConsent === 'pending' && (!deepScan || deepScan?.status === 'awaiting_confirmation')))
                                && !(deepScanConsent !== 'declined' && (deepScan?.status === 'running' || deepScan?.status === 'done' || deepScan?.status === 'error' || deepScan?.status === 'unavailable'))"
                        >
                            <ng-container *ngIf="needsDeepScan && deepScan?.status === 'awaiting_confirmation' && deepScanConsent === 'pending'">
                                <div class="inv-deep-scan-copy">
                                    <p *ngIf="deepScan?.mode === 'topup'">
                                        This address has <strong>{{ deepScan?.newTx || 0 | number }}</strong> new transactions since the last deep scan.
                                        Merging them will use approximately <strong>{{ deepScan?.estimatedMb || 0 }} MB</strong>
                                        and deduct <strong>{{ deepScan?.credits || 0 }}</strong> credit(s). Proceed?
                                    </p>
                                    <p *ngIf="deepScan?.mode !== 'topup'">
                                        This address has <strong>{{ deepScan?.total || 0 | number }}</strong> transactions.
                                        A full-history deep scan will use approximately <strong>{{ deepScan?.estimatedMb || 0 }} MB</strong>
                                        and deduct <strong>{{ deepScan?.credits || 0 }}</strong> credit(s). Proceed?
                                    </p>
                                    <p class="text-red" *ngIf="deepScanCreditError || deepScan?.has_sufficient_credits === false">
                                        {{ deepScanInsufficientMessage }}
                                    </p>
                                </div>
                                <div class="deep-scan-actions">
                                    <button
                                        type="button"
                                        class="run-trace-btn"
                                        [disabled]="!canConfirmDeepScan"
                                        (click)="approveDeepScan()">
                                        Proceed — deduct {{ deepScan?.credits || 0 }} credit(s)
                                    </button>
                                    <button type="button" class="export-outline-btn" (click)="declineDeepScan()">Skip</button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!(needsDeepScan && deepScan?.status === 'awaiting_confirmation' && deepScanConsent === 'pending')">
                                <p class="inv-note" *ngIf="displayNote">{{ displayNote }}</p>
                                <button
                                    *ngIf="needsDeepScan && !deepScan && deepScanConsent === 'pending'"
                                    type="button"
                                    class="run-trace-btn"
                                    [disabled]="deepScanPreviewLoading"
                                    (click)="startDeepScanPreview()">
                                    <i class="fas" [ngClass]="deepScanPreviewLoading ? 'fa-spinner fa-spin' : 'fa-magnifying-glass'"></i>
                                    {{ deepScanPreviewLoading ? 'Checking...' : 'Check full history' }}
                                </button>
                            </ng-container>
                        </div>
                        <div
                            class="deep-scan-banner inv-header-scan-banner"
                            *ngIf="deepScanConsent !== 'declined' && deepScan?.status === 'running'"
                        >
                            <p class="muted">
                                <i class="fas fa-spinner fa-spin"></i>
                                {{ deepScanRunningMessage }}
                            </p>
                        </div>
                        <div
                            class="deep-scan-banner inv-header-scan-banner"
                            *ngIf="deepScanConsent !== 'declined' && deepScan?.status === 'done'"
                        >
                            <p class="muted">{{ deepScanDoneMessage }}</p>
                        </div>
                        <div
                            class="deep-scan-banner inv-header-scan-banner"
                            *ngIf="deepScanConsent !== 'declined' && (deepScan?.status === 'error' || deepScan?.status === 'unavailable')"
                        >
                            <p class="text-red">
                                Full-history deep scan is currently unavailable; top senders/receivers cover the most recent
                                {{ (inv.counterpartyScan?.analyzed || 0) | number }} transactions.
                                <ng-container *ngIf="deepScan?.credits_refunded > 0">
                                    {{ deepScan.credits_refunded }} credit(s) were restored.
                                </ng-container>
                            </p>
                        </div>
                    </section>

                    <!-- Sticky nav -->
                    <nav class="section-nav" aria-label="Jump to section">
                        <button type="button" class="nav-chip" [class.muted]="isAtTop" (click)="jumpToTop()"><i class="fas fa-arrow-up"></i> Top</button>
                        <span class="nav-sep"></span>
                        <button type="button" class="nav-chip" *ngFor="let s of navSections" [class.active]="activeNavSection === s.id" (click)="scrollToSection(s.id)">{{ s.label }}</button>
                    </nav>

                    <!-- KPI grid -->
                    <div class="kpi-grid">
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('received')"
                            (keydown.enter)="openDetailDrawer('received')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('received')"
                        >
                            <div class="kpi-label">
                                <span class="btc-dot"></span> Total Received
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('received', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'received'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.received.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.received.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ fmtBtc(inv.profile?.totalReceived) }} {{ inv.symbol }}</div>
                            <div class="kpi-sub">{{ fiatPair(inv.usd?.totalReceived, inv.inr?.totalReceived) }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('sent')"
                            (keydown.enter)="openDetailDrawer('sent')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('sent')"
                        >
                            <div class="kpi-label">
                                <span class="btc-dot"></span> Total Sent
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('sent', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'sent'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.sent.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.sent.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ fmtBtc(inv.profile?.totalSent) }} {{ inv.symbol }}</div>
                            <div class="kpi-sub">{{ fiatPair(inv.usd?.totalSent, inv.inr?.totalSent) }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('balance')"
                            (keydown.enter)="openDetailDrawer('balance')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('balance')"
                        >
                            <div class="kpi-label">
                                <span class="btc-dot"></span> Balance
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('balance', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'balance'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.balance.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.balance.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ fmtBtc(inv.profile?.balance) }} {{ inv.symbol }}</div>
                            <div class="kpi-sub">{{ fiatPair(inv.usd?.balance, inv.inr?.balance) }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('transactions')"
                            (keydown.enter)="openDetailDrawer('transactions')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('transactions')"
                        >
                            <div class="kpi-label">
                                <i class="fas fa-hashtag text-blue"></i> Transactions
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('transactions', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'transactions'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.transactions.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.transactions.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ (inv.profile?.txCount || 0) | number }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('activity')"
                            (keydown.enter)="openDetailDrawer('activity')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('activity')"
                        >
                            <div class="kpi-label">
                                <i class="far fa-calendar text-purple"></i> First Seen
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('firstSeen', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'firstSeen'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.firstSeen.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.firstSeen.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ formatDateClient(effectiveFirstSeen) }}</div>
                            <div class="kpi-sub" *ngIf="effectiveFirstSeen">{{ formatTimeClient(effectiveFirstSeen) }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('activity')"
                            (keydown.enter)="openDetailDrawer('activity')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('activity')"
                        >
                            <div class="kpi-label">
                                <i class="far fa-clock text-cyan"></i> Last Seen
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('lastSeen', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'lastSeen'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.lastSeen.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.lastSeen.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ formatDateClient(effectiveLastSeen) }}</div>
                            <div class="kpi-sub" *ngIf="effectiveLastSeen">{{ formatTimeClient(effectiveLastSeen) }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('activity')"
                            (keydown.enter)="openDetailDrawer('activity')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('activity')"
                        >
                            <div class="kpi-label">
                                <i class="fas fa-chart-line text-amber"></i> Address Age
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('addressAge', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'addressAge'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.addressAge.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.addressAge.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ effectiveAddressAge }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                        <div
                            class="kpi-card clickable"
                            role="button"
                            tabindex="0"
                            (click)="openDetailDrawer('abuse')"
                            (keydown.enter)="openDetailDrawer('abuse')"
                            (keydown.space)="$event.preventDefault(); openDetailDrawer('abuse')"
                        >
                            <div class="kpi-label">
                                <i class="fas fa-triangle-exclamation text-red"></i> Abuse Reports
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('abuse', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'abuse'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.abuse.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.abuse.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="kpi-value">{{ totalAbuse }}</div>
                            <div class="kpi-hint">View details →</div>
                        </div>
                    </div>

                    <!-- Deep scan (BTC incomplete counterparty scan) — vendor is called only if the user starts it -->
                    <div class="deep-scan-banner" *ngIf="needsDeepScan">
                        <ng-container *ngIf="!deepScan && deepScanConsent === 'pending'">
                            <p>
                                This address has more transactions than the initial scan.
                                A full-history deep scan uses extra credits. Top senders/receivers below cover the most recent
                                {{ (inv.counterpartyScan?.analyzed || 0) | number }} transactions.
                            </p>
                            <div class="deep-scan-actions">
                                <button
                                    type="button"
                                    class="run-trace-btn"
                                    [disabled]="deepScanPreviewLoading"
                                    (click)="startDeepScanPreview()">
                                    <i class="fas" [ngClass]="deepScanPreviewLoading ? 'fa-spinner fa-spin' : 'fa-magnifying-glass'"></i>
                                    {{ deepScanPreviewLoading ? 'Checking...' : 'Check full history' }}
                                </button>
                                <button type="button" class="export-outline-btn" (click)="declineDeepScan()">Skip</button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="deepScan?.status === 'awaiting_confirmation' && deepScanConsent === 'pending'">
                            <p *ngIf="deepScan?.mode === 'topup'">
                                This address has <strong>{{ deepScan?.newTx || 0 | number }}</strong> new transactions since the last deep scan.
                                Merging them will use approximately <strong>{{ deepScan?.estimatedMb || 0 }} MB</strong>
                                and deduct <strong>{{ deepScan?.credits || 0 }}</strong> credit(s). Proceed?
                            </p>
                            <p *ngIf="deepScan?.mode !== 'topup'">
                                This address has <strong>{{ deepScan?.total || 0 | number }}</strong> transactions.
                                A full-history deep scan will use approximately <strong>{{ deepScan?.estimatedMb || 0 }} MB</strong>
                                and deduct <strong>{{ deepScan?.credits || 0 }}</strong> credit(s). Proceed?
                            </p>
                            <p class="text-red" *ngIf="deepScanCreditError || deepScan?.has_sufficient_credits === false">
                                {{ deepScanInsufficientMessage }}
                            </p>
                            <div class="deep-scan-actions">
                                <button
                                    type="button"
                                    class="run-trace-btn"
                                    [disabled]="!canConfirmDeepScan"
                                    (click)="approveDeepScan()">
                                    Proceed — deduct {{ deepScan?.credits || 0 }} credit(s)
                                </button>
                                <button type="button" class="export-outline-btn" (click)="declineDeepScan()">Skip</button>
                            </div>
                        </ng-container>
                        <p class="muted" *ngIf="deepScanConsent === 'declined'">
                            Deep scan skipped — no credits deducted. Top senders/receivers below cover the most recent
                            {{ (inv.counterpartyScan?.analyzed || 0) | number }} transactions.
                        </p>
                        <p class="muted" *ngIf="deepScanConsent !== 'declined' && deepScan?.status === 'running'">
                            <i class="fas fa-spinner fa-spin"></i>
                            {{ deepScanRunningMessage }}
                        </p>
                        <p class="muted" *ngIf="deepScanConsent !== 'declined' && deepScan?.status === 'done'">
                            {{ deepScanDoneMessage }}
                        </p>
                        <p class="text-red" *ngIf="deepScanConsent !== 'declined' && (deepScan?.status === 'error' || deepScan?.status === 'unavailable')">
                            Full-history deep scan is currently unavailable; top senders/receivers cover the most recent
                            {{ (inv.counterpartyScan?.analyzed || 0) | number }} transactions.
                            <ng-container *ngIf="deepScan?.credits_refunded > 0">
                                {{ deepScan.credits_refunded }} credit(s) were restored.
                            </ng-container>
                        </p>
                    </div>

                    <!-- Counterparties -->
                    <div class="cp-grid" id="section-counterparties" *ngIf="displayTopSenders.length || displayTopReceivers.length">
                        <section class="panel cp-panel is-senders" *ngIf="displayTopSenders.length">
                            <h3 class="panel-title">
                                <i class="fas fa-arrow-down-left text-sender"></i>
                                Top Senders
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('topSenders', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'topSenders'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.topSenders.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.topSenders.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                            <div class="cp-table-wrap">
                                <table class="data-table cp-table">
                                    <thead>
                                        <tr>
                                            <th>Address</th>
                                            <th class="num">Amount</th>
                                            <th class="num">Txns</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let cp of displayTopSenders">
                                            <td>
                                                <div class="cp-addr-row">
                                                    <span class="mono cp-addr" [title]="cp.address">{{ shortAddrCp(cp.address) }}</span>
                                                    <button
                                                        type="button"
                                                        class="cp-investigate"
                                                        title="Investigate this address"
                                                        (click)="investigateAddress(cp.address)"
                                                    >
                                                        <i class="fas fa-magnifying-glass"></i>
                                                    </button>
                                                </div>
                                                <span class="mini-tag" *ngIf="cp.label?.name">{{ cp.label.name }} · {{ cp.label.type }}</span>
                                            </td>
                                            <td class="num cp-amount">
                                                <span class="cp-amount-value">{{ fmtBtc(cp.totalBtc) }}</span>
                                                <span class="cp-amount-unit">{{ inv.symbol }}</span>
                                            </td>
                                            <td class="num cp-txns">{{ cp.txCount }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <section class="panel cp-panel is-receivers" *ngIf="displayTopReceivers.length">
                            <h3 class="panel-title">
                                <i class="fas fa-arrow-up-right text-receiver"></i>
                                Top Receivers
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('topReceivers', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                    *ngIf="activeInfoHint === 'topReceivers'"
                                    [class.place-top]="infoHintPlacement === 'top'"
                                    [class.place-bottom]="infoHintPlacement === 'bottom'"
                                    [ngStyle]="infoHintStyle"
                                    (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.topReceivers.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.topReceivers.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                            <div class="cp-table-wrap">
                                <table class="data-table cp-table">
                                    <thead>
                                        <tr>
                                            <th>Address</th>
                                            <th class="num">Amount</th>
                                            <th class="num">Txns</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let cp of displayTopReceivers">
                                            <td>
                                                <div class="cp-addr-row">
                                                    <span class="mono cp-addr" [title]="cp.address">{{ shortAddrCp(cp.address) }}</span>
                                                    <button
                                                        type="button"
                                                        class="cp-investigate"
                                                        title="Investigate this address"
                                                        (click)="investigateAddress(cp.address)"
                                                    >
                                                        <i class="fas fa-magnifying-glass"></i>
                                                    </button>
                                                </div>
                                                <span class="mini-tag" *ngIf="cp.label?.name">{{ cp.label.name }} · {{ cp.label.type }}</span>
                                            </td>
                                            <td class="num cp-amount">
                                                <span class="cp-amount-value">{{ fmtBtc(cp.totalBtc) }}</span>
                                                <span class="cp-amount-unit">{{ inv.symbol }}</span>
                                            </td>
                                            <td class="num cp-txns">{{ cp.txCount }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>

                    <!-- Money Flow (SVG Sankey, matches Ryno reference) -->
                    <section class="panel" id="section-flow" *ngIf="hasFlowData">
                        <div class="panel-head-row">
                            <h3 class="panel-title">
                                <span class="btc-dot" aria-hidden="true"></span> Money Flow
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('moneyFlow', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                        *ngIf="activeInfoHint === 'moneyFlow'"
                                        [class.place-top]="infoHintPlacement === 'top'"
                                        [class.place-bottom]="infoHintPlacement === 'bottom'"
                                        [ngStyle]="infoHintStyle"
                                        (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.moneyFlow.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.moneyFlow.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                            <button
                                type="button"
                                class="section-filter-btn"
                                [class.active]="showFlowFilters || flowActiveFilterCount > 0"
                                (click)="showFlowFilters = !showFlowFilters"
                            >
                                <i class="fas fa-sliders"></i>
                                Filter{{ flowActiveFilterCount > 0 ? ' (' + flowActiveFilterCount + ')' : '' }}
                            </button>
                        </div>
                        <p class="panel-sub">Largest observed inflows and outflows. Link thickness &#8733; value. Red = flagged by sanctions / mixer / community screening. Click a node to investigate it here.</p>

                        <div class="section-filters" *ngIf="showFlowFilters">
                            <label class="filter-label">Minimum amount ({{ inv.symbol }})</label>
                            <div class="filter-row">
                                <input
                                    class="filter-input mono"
                                    type="number"
                                    inputmode="decimal"
                                    min="0"
                                    step="any"
                                    [(ngModel)]="flowMinAmt"
                                    placeholder="Show flows ≥ this value"
                                />
                                <button
                                    type="button"
                                    class="filter-clear-btn"
                                    *ngIf="flowActiveFilterCount > 0"
                                    (click)="clearFlowFilters()"
                                >
                                    <i class="fas fa-xmark"></i> Clear
                                </button>
                            </div>
                        </div>

                        <div class="filter-empty" *ngIf="!flowGraph">
                            No flows match the current minimum-amount filter.
                        </div>
                        <div class="flow-graph-wrap" *ngIf="flowGraph as fg">
                            <svg
                                class="flow-graph-svg"
                                [attr.viewBox]="'0 0 ' + fg.width + ' ' + fg.height"
                                role="img"
                                aria-label="Money flow graph"
                            >
                                <text *ngIf="fg.inflows.length" [attr.x]="fg.leftX" y="12" class="flow-col-header in">
                                    INFLOWS ({{ fg.inflows.length }})
                                </text>
                                <text
                                    *ngIf="fg.outflows.length"
                                    [attr.x]="fg.rightX + fg.nodeW"
                                    y="12"
                                    text-anchor="end"
                                    class="flow-col-header out"
                                >
                                    OUTFLOWS ({{ fg.outflows.length }})
                                </text>

                                <ng-container *ngFor="let link of fg.inLinks; let i = index">
                                    <path
                                        [attr.id]="'flow-in-' + i"
                                        [attr.d]="link.d"
                                        fill="none"
                                        stroke-linecap="round"
                                        class="flow-link in"
                                        [attr.stroke-width]="link.stroke"
                                    />
                                    <polygon
                                        *ngFor="let delay of flowArrowDelays"
                                        points="0,-5 10,0 0,5"
                                        class="flow-arrow in"
                                    >
                                        <animateMotion
                                            [attr.dur]="flowArrowDuration"
                                            repeatCount="indefinite"
                                            rotate="auto"
                                            calcMode="linear"
                                            [attr.begin]="delay"
                                        >
                                            <mpath [attr.href]="'#flow-in-' + i" />
                                        </animateMotion>
                                    </polygon>
                                </ng-container>
                                <ng-container *ngFor="let link of fg.outLinks; let i = index">
                                    <path
                                        [attr.id]="'flow-out-' + i"
                                        [attr.d]="link.d"
                                        fill="none"
                                        stroke-linecap="round"
                                        class="flow-link out"
                                        [attr.stroke-width]="link.stroke"
                                    />
                                    <polygon
                                        *ngFor="let delay of flowArrowDelays"
                                        points="0,-5 10,0 0,5"
                                        class="flow-arrow out"
                                    >
                                        <animateMotion
                                            [attr.dur]="flowArrowDuration"
                                            repeatCount="indefinite"
                                            rotate="auto"
                                            calcMode="linear"
                                            [attr.begin]="delay"
                                        >
                                            <mpath [attr.href]="'#flow-out-' + i" />
                                        </animateMotion>
                                    </polygon>
                                </ng-container>

                                <g
                                    *ngFor="let node of fg.inflows"
                                    class="flow-svg-node"
                                    (click)="investigateAddress(node.address)"
                                    role="button"
                                    [attr.aria-label]="'Investigate ' + node.address"
                                >
                                    <rect
                                        [attr.x]="node.x"
                                        [attr.y]="node.y"
                                        [attr.width]="fg.nodeW"
                                        [attr.height]="fg.nodeH"
                                        rx="8"
                                        class="flow-svg-rect in"
                                    />
                                    <text [attr.x]="node.x + 10" [attr.y]="node.y + 18" class="flow-svg-addr">{{ node.short }}</text>
                                    <text [attr.x]="node.x + 10" [attr.y]="node.y + 35" class="flow-svg-val in">
                                        {{ node.valueLabel }} · {{ node.txCount }} tx
                                    </text>
                                </g>

                                <g
                                    *ngFor="let node of fg.outflows"
                                    class="flow-svg-node"
                                    (click)="investigateAddress(node.address)"
                                    role="button"
                                    [attr.aria-label]="'Investigate ' + node.address"
                                >
                                    <rect
                                        [attr.x]="node.x"
                                        [attr.y]="node.y"
                                        [attr.width]="fg.nodeW"
                                        [attr.height]="fg.nodeH"
                                        rx="8"
                                        class="flow-svg-rect out"
                                    />
                                    <text [attr.x]="node.x + 10" [attr.y]="node.y + 18" class="flow-svg-addr">{{ node.short }}</text>
                                    <text [attr.x]="node.x + 10" [attr.y]="node.y + 35" class="flow-svg-val out">
                                        {{ node.valueLabel }} · {{ node.txCount }} tx
                                    </text>
                                    <text
                                        *ngIf="node.label"
                                        [attr.x]="node.x + fg.nodeW - 8"
                                        [attr.y]="node.y + 18"
                                        text-anchor="end"
                                        class="flow-svg-badge"
                                    >{{ node.label }}</text>
                                </g>

                                <g class="flow-svg-target">
                                    <rect
                                        [attr.x]="fg.centerX"
                                        [attr.y]="fg.centerY - fg.centerH / 2"
                                        [attr.width]="fg.centerW"
                                        [attr.height]="fg.centerH"
                                        rx="10"
                                        class="flow-svg-rect target"
                                    />
                                    <text
                                        [attr.x]="fg.centerX + fg.centerW / 2"
                                        [attr.y]="fg.centerY - 8"
                                        text-anchor="middle"
                                        class="flow-svg-target-label"
                                    >TARGET</text>
                                    <text
                                        [attr.x]="fg.centerX + fg.centerW / 2"
                                        [attr.y]="fg.centerY + 10"
                                        text-anchor="middle"
                                        class="flow-svg-addr"
                                        (click)="copyText(displayAddress)"
                                    >{{ fg.targetShort }}</text>
                                    <text
                                        *ngIf="fg.entityName"
                                        [attr.x]="fg.centerX + fg.centerW / 2"
                                        [attr.y]="fg.centerY + 24"
                                        text-anchor="middle"
                                        class="flow-svg-entity"
                                    >{{ fg.entityName }}</text>
                                </g>
                            </svg>
                        </div>
                    </section>

                    <!-- Timeline -->
                    <section class="panel" id="section-timeline" *ngIf="inv.transactions?.length">
                        <div class="panel-head-row">
                            <h3 class="panel-title">
                                <span class="btc-dot" aria-hidden="true"></span>
                                Transaction Timeline
                                <span class="panel-title-meta">
                                    ({{ filteredTransactions.length }}{{ filteredTransactions.length !== inv.transactions.length ? ' of ' + inv.transactions.length : '' }} shown)
                                </span>
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('timeline', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                        *ngIf="activeInfoHint === 'timeline'"
                                        [class.place-top]="infoHintPlacement === 'top'"
                                        [class.place-bottom]="infoHintPlacement === 'bottom'"
                                        [ngStyle]="infoHintStyle"
                                        (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.timeline.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.timeline.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                            <button
                                type="button"
                                class="section-filter-btn"
                                [class.active]="showTxFilters || txActiveFilterCount > 0"
                                (click)="showTxFilters = !showTxFilters"
                            >
                                <i class="fas fa-sliders"></i>
                                Filters{{ txActiveFilterCount > 0 ? ' (' + txActiveFilterCount + ')' : '' }}
                            </button>
                        </div>

                        <div class="section-filters" *ngIf="showTxFilters">
                            <div class="filter-group">
                                <label class="filter-label">Direction</label>
                                <div class="filter-dir-row">
                                    <button type="button" class="dir-chip" [class.active]="txDirFilter === 'all'" (click)="txDirFilter = 'all'">All</button>
                                    <button type="button" class="dir-chip in" [class.active]="txDirFilter === 'in'" (click)="txDirFilter = 'in'">Received</button>
                                    <button type="button" class="dir-chip out" [class.active]="txDirFilter === 'out'" (click)="txDirFilter = 'out'">Sent</button>
                                </div>
                            </div>
                            <div class="filter-grid">
                                <div class="filter-group">
                                    <label class="filter-label">Min amount ({{ inv.symbol }})</label>
                                    <input class="filter-input mono" type="number" inputmode="decimal" min="0" step="any" [(ngModel)]="txMinAmt" placeholder="0" />
                                </div>
                                <div class="filter-group">
                                    <label class="filter-label">Max amount ({{ inv.symbol }})</label>
                                    <input class="filter-input mono" type="number" inputmode="decimal" min="0" step="any" [(ngModel)]="txMaxAmt" placeholder="∞" />
                                </div>
                            </div>
                            <div class="filter-grid">
                                <div class="filter-group">
                                    <label class="filter-label">From (IST)</label>
                                    <input class="filter-input mono" type="datetime-local" [(ngModel)]="txFromDate" />
                                </div>
                                <div class="filter-group">
                                    <label class="filter-label">To (IST)</label>
                                    <input class="filter-input mono" type="datetime-local" [(ngModel)]="txToDate" />
                                </div>
                            </div>
                            <button type="button" class="filter-clear-btn" *ngIf="txActiveFilterCount > 0" (click)="clearTxFilters()">
                                <i class="fas fa-xmark"></i> Clear filters
                            </button>
                        </div>

                        <div class="filter-empty" *ngIf="!displayedTransactions.length">
                            No transactions match the current filters.
                        </div>
                        <div class="tx-list" *ngIf="displayedTransactions.length">
                            <div class="tx-row" *ngFor="let tx of displayedTransactions">
                                <div class="tx-left">
                                    <i class="fas" [ngClass]="tx.direction === 'in' ? 'fa-arrow-down-left text-sender' : 'fa-arrow-up-right text-receiver'"></i>
                                    <div>
                                        <div class="tx-hash-row">
                                            <span class="mono">{{ shortHash(tx.hash) }}</span>
                                            <button
                                                type="button"
                                                class="tx-prefill-btn"
                                                title="Look up this transaction"
                                                (click)="prefillWalletSearch(tx.hash)"
                                            >
                                                <i class="fas fa-magnifying-glass"></i>
                                            </button>
                                        </div>
                                        <div class="tx-time">
                                            <span class="tx-datetime">{{ formatTxTime(tx.time) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="tx-right">
                                    <div class="tx-amt" [class.out]="tx.direction === 'out'" [class.in]="tx.direction === 'in'">
                                        {{ tx.direction === 'out' ? '-' : '+' }}{{ fmtBtc(tx.valueBtc) }}
                                        <span class="btc-dot sm"></span>
                                    </div>
                                    <div class="tx-fiat" *ngIf="fiatPair(tx.usdAtTime, tx.inrAtTime) !== '—'">
                                        Value on <span class="tx-datetime">{{ formatTxDateShort(tx.time) }}</span>: <span class="tx-fiat-amt">{{ fiatPair(tx.usdAtTime, tx.inrAtTime) }}</span>
                                    </div>
                                    <div class="tx-fiat tx-fiat-now" *ngIf="txCurrentFiat(tx) as nowFiat">
                                        Value
                                        <ng-container *ngIf="searchAsOfLabel !== 'N/A'; else valueAsOfNow">
                                            as of <span class="tx-datetime">{{ searchAsOfLabel }}</span>
                                        </ng-container>
                                        <ng-template #valueAsOfNow>now</ng-template>:
                                        <span class="tx-fiat-amt">{{ nowFiat }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="show-more-btn" *ngIf="filteredTransactions.length > 10" (click)="showAllTx = !showAllTx">
                            {{ showAllTx ? 'Show Less' : ('Show All ' + filteredTransactions.length + ' Transactions') }}
                            <i class="fas" [ngClass]="showAllTx ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        </button>

                        <div class="tx-lookup-panel" *ngIf="txLookupLoading || txLookupResult || txLookupError">
                            <div class="panel-head-row">
                                <h4 class="panel-title"><i class="fas fa-receipt text-cyan"></i> Transaction Lookup</h4>
                                <button type="button" class="icon-btn tiny" (click)="closeTxLookup()" title="Close"><i class="fas fa-xmark"></i></button>
                            </div>
                            <p class="muted" *ngIf="txLookupLoading"><i class="fas fa-spinner fa-spin"></i> Looking up transaction…</p>
                            <p class="text-red" *ngIf="txLookupError">{{ txLookupError }}</p>
                            <ng-container *ngIf="txLookupResult as tx">
                                <div class="tx-lookup-meta">
                                    <div><span>Hash</span><button type="button" class="linkish mono" (click)="copyText(tx.hash)">{{ tx.hash }}</button></div>
                                    <div><span>Chain</span><strong>{{ tx.chainName }} ({{ tx.symbol }})</strong></div>
                                    <div><span>Status</span><strong>{{ tx.status }}</strong></div>
                                    <div><span>Value</span><strong>{{ fmtBtc(tx.value) }} {{ tx.symbol }}</strong></div>
                                    <div><span>Fee</span><strong>{{ fmtBtc(tx.fee) }} {{ tx.symbol }}</strong></div>
                                    <div *ngIf="tx.explorer"><span>Explorer</span><a [href]="tx.explorer" target="_blank" rel="noopener">Open</a></div>
                                </div>
                                <div class="tx-lookup-cols" *ngIf="tx.from?.length || tx.to?.length">
                                    <div>
                                        <h5>From</h5>
                                        <button type="button" class="linkish mono block" *ngFor="let a of tx.from" (click)="investigateAddress(a)">{{ shortAddr(a) }}</button>
                                    </div>
                                    <div>
                                        <h5>To</h5>
                                        <button type="button" class="linkish mono block" *ngFor="let a of tx.to" (click)="investigateAddress(a)">{{ shortAddr(a) }}</button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </section>

                    <!-- Abuse Check -->
                    <section class="panel abuse-panel" id="section-abuse" [class.clean]="totalAbuse === 0" [class.dirty]="totalAbuse > 0">
                        <div class="panel-head-row">
                            <h3 class="panel-title" [class.text-emerald]="totalAbuse === 0" [class.text-red]="totalAbuse > 0">
                                <i class="fas" [ngClass]="totalAbuse === 0 ? 'fa-shield-halved' : 'fa-triangle-exclamation'"></i>
                                Abuse Check
                            </h3>
                            <button type="button" class="export-outline-btn danger" (click)="openReportModal()">
                                <i class="fas fa-flag"></i> Report Address
                            </button>
                        </div>
                        <p class="panel-sub">We checked this address on {{ inv.abuseSources?.length || 0 }} outside safety databases and on our own user reports.</p>
                        <div class="abuse-grid">
                            <div class="abuse-card" *ngFor="let s of inv.abuseSources">
                                <div class="abuse-card-top">
                                    <span>{{ s.source }}</span>
                                    <span class="mono" [class.text-emerald]="s.status === 'ok' && !s.count" [class.text-red]="s.count > 0" [class.muted]="s.status !== 'ok'">{{ s.status === 'ok' ? s.count : '-' }}</span>
                                </div>
                                <p class="abuse-msg text-emerald" *ngIf="s.status === 'ok' && !s.count">✓ Clean — no findings</p>
                                <p class="abuse-msg muted" *ngIf="s.status !== 'ok'">-</p>
                                <p class="abuse-origin" *ngIf="s.origin">{{ s.origin }}</p>
                            </div>
                            <div class="abuse-card">
                                <div class="abuse-card-top">
                                    <span><i class="fas fa-users text-amber"></i> Community</span>
                                    <span class="mono" [class.text-emerald]="!(inv.communityReportCount)" [class.text-red]="inv.communityReportCount > 0">{{ inv.communityReportCount || 0 }}</span>
                                </div>
                                <p class="abuse-msg muted" *ngIf="!(inv.communityReportCount)">No community reports yet.</p>
                                <div class="community-cats" *ngIf="inv.communityCategories?.length">
                                    <span class="mini-tag" *ngFor="let c of inv.communityCategories">{{ c.category }} · {{ c.count }}</span>
                                </div>
                            </div>
                        </div>
                        <p class="panel-foot" *ngIf="totalAbuse === 0">No safety database flagged this address — that is a good sign.</p>
                    </section>

                    <!-- Trace Funds -->
                    <section class="panel" id="section-trace">
                        <div class="panel-head-row">
                            <h3 class="panel-title">
                                <span class="btc-dot" aria-hidden="true"></span>
                                Trace Funds
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('trace', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                        *ngIf="activeInfoHint === 'trace'"
                                        [class.place-top]="infoHintPlacement === 'top'"
                                        [class.place-bottom]="infoHintPlacement === 'bottom'"
                                        [ngStyle]="infoHintStyle"
                                        (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.trace.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.trace.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                        </div>
                        <p class="panel-sub">We follow the biggest single money trail several steps deep to see where the money finally goes, or where it first came from. It stops when it reaches a known exchange, mixer or blocked address.</p>

                        <div class="trace-bar">
                            <div class="trace-toggles">
                                <button type="button" class="toggle-btn" [class.active]="traceDirection === 'downstream'" (click)="traceDirection = 'downstream'">
                                    <i class="fas fa-arrow-down"></i> Downstream (where funds went)
                                </button>
                                <button type="button" class="toggle-btn" [class.active]="traceDirection === 'upstream'" (click)="traceDirection = 'upstream'">
                                    <i class="fas fa-arrow-up"></i> Upstream (source of funds)
                                </button>
                            </div>
                            <label class="depth-label">
                                Depth
                                <select class="depth-select" [(ngModel)]="traceDepth">
                                    <option [ngValue]="2">2 hops</option>
                                    <option [ngValue]="3">3 hops</option>
                                    <option [ngValue]="4">4 hops</option>
                                    <option [ngValue]="5">5 hops</option>
                                    <option [ngValue]="6">6 hops</option>
                                </select>
                            </label>
                            <button type="button" class="run-trace-btn" (click)="runTrace()" [disabled]="traceLoading">
                                <i class="fas" [ngClass]="traceLoading ? 'fa-spinner fa-spin' : (traceResult ? 'fa-rotate' : 'fa-route')"></i>
                                {{ traceLoading ? 'Tracing…' : (traceResult ? 'Re-run trace' : 'Run trace') }}
                            </button>
                        </div>
                        <p class="text-red" *ngIf="traceError">{{ traceError }}</p>
                        <p class="muted trace-loading" *ngIf="traceLoading && !traceResult">
                            <i class="fas fa-spinner fa-spin"></i>
                            Following the largest {{ traceDirection === 'downstream' ? 'outgoing' : 'incoming' }} flow {{ traceDepth }} hops deep…
                        </p>

                        <div class="trace-history" *ngIf="traceHistoryLoading || traceHistory.length">
                            <div class="panel-head-row">
                                <h4 class="panel-title sm"><i class="fas fa-clock-rotate-left text-amber"></i> Trace history</h4>
                                <span class="muted small" *ngIf="traceHistoryLoading"><i class="fas fa-spinner fa-spin"></i> Loading…</span>
                            </div>
                            <p class="panel-sub" *ngIf="!traceHistoryLoading && !traceHistory.length">No saved traces for this investigation yet.</p>
                            <button
                                type="button"
                                class="trace-history-row"
                                *ngFor="let entry of traceHistory"
                                (click)="openSavedTrace(entry)"
                            >
                                <span class="trace-hist-dir" [class.up]="entry.direction === 'upstream'">
                                    {{ entry.direction === 'upstream' ? 'Upstream' : 'Downstream' }}
                                </span>
                                <span class="trace-hist-meta">
                                    {{ entry.max_hops }} hops · {{ entry.hop_count || entry.result?.nodes?.length || 0 }} nodes · {{ formatTraceHistoryTime(entry.created_on) }}
                                </span>
                                <span class="trace-hist-open">Open</span>
                            </button>
                        </div>

                        <div class="trace-result" *ngIf="traceResult as tr">
                            <div class="trace-path">
                                <ng-container *ngFor="let node of tr.nodes; let i = index">
                                    <div class="trace-connector" *ngIf="node.hop !== 0">
                                        <i class="fas" [ngClass]="tr.direction === 'upstream' || traceDirection === 'upstream' ? 'fa-arrow-up-right' : 'fa-arrow-down-right'"></i>
                                        <span class="trace-connector-amt">
                                            {{ fmtTrace(node.valueIn) }}
                                            <span class="btc-dot sm" aria-hidden="true"></span>
                                        </span>
                                        <span class="trace-connector-meta" *ngIf="node.txCountWithPrev">
                                            across {{ node.txCountWithPrev }} tx{{ node.txCountWithPrev === 1 ? '' : 's' }}
                                        </span>
                                        <span class="trace-connector-meta">
                                            {{ (tr.direction === 'upstream' || traceDirection === 'upstream') ? 'received from' : 'sent to' }}
                                            <i class="fas" [ngClass]="(tr.direction === 'upstream' || traceDirection === 'upstream') ? 'fa-arrow-up' : 'fa-arrow-down'"></i>
                                        </span>
                                    </div>

                                    <div
                                        class="trace-hop"
                                        [class.sanctioned]="node.sanctioned"
                                        [class.origin]="node.hop === 0"
                                        [class.terminal]="node.terminal && node.hop !== 0"
                                    >
                                        <div class="trace-hop-icon">
                                            <i class="fas" [ngClass]="traceHopIcon(node)"></i>
                                        </div>
                                        <div class="trace-hop-body">
                                            <div class="trace-hop-top">
                                                <span class="hop-idx">{{ node.hop === 0 ? 'Origin' : ('Hop ' + node.hop) }}</span>
                                                <span class="mini-tag" *ngIf="node.label?.name">{{ node.label.name }} · {{ node.label.type }}</span>
                                                <span class="mini-tag danger" *ngIf="node.sanctioned">Sanctioned</span>
                                            </div>
                                            <div class="trace-hop-addr-row">
                                                <button
                                                    type="button"
                                                    class="trace-addr-btn"
                                                    (click)="copyText(node.address)"
                                                    [title]="node.address"
                                                >
                                                    <span class="mono">{{ shortAddrTrace(node.address) }}</span>
                                                    <i class="fas fa-copy"></i>
                                                </button>
                                                <span class="trace-hop-value" *ngIf="node.hop !== 0 && node.valueIn != null">
                                                    {{ fmtTrace(node.valueIn) }} {{ tr.symbol || inv.symbol }}
                                                </span>
                                            </div>
                                            <div class="trace-node-meta">
                                                bal {{ fmtTrace(node.balance) }}
                                                <span class="btc-dot sm" aria-hidden="true"></span>
                                                · recv {{ fmtTrace(node.totalReceived) }}
                                                · sent {{ fmtTrace(node.totalSent) }}
                                                · {{ node.txCount || 0 | number }} tx
                                            </div>
                                            <p class="trace-terminal-note" *ngIf="node.terminalReason">{{ node.terminalReason }}</p>
                                            <button
                                                type="button"
                                                class="trace-investigate"
                                                *ngIf="node.hop > 0"
                                                (click)="investigateAddress(node.address)"
                                            >Investigate this address →</button>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <p class="trace-note" *ngIf="tr.note">{{ tr.note }}</p>
                            <p class="text-red small" *ngIf="tr.errors?.length">{{ tr.errors.join(' ') }}</p>
                        </div>
                    </section>

                    <!-- Legal Targets -->
                    <section class="panel" id="section-lea" *ngIf="inv.lea">
                        <h3 class="panel-title"><i class="fas fa-scale-balanced text-amber"></i> Legal Process Targets</h3>
                        <p class="panel-sub">The real services this address used that can be sent a legal request — who holds the records, which country they are in, and how to reach their compliance team.</p>
                        <div class="lea-stats">
                            <div class="lea-stat"><span>Counterparties identified</span><strong>{{ inv.lea.coverage?.attributedCounterparties || 0 }} / {{ inv.lea.coverage?.totalCounterparties || 0 }}</strong></div>
                            <div class="lea-stat"><span>Value attributed</span><strong class="text-amber">{{ leaAttributedValuePct }}%</strong></div>
                            <div class="lea-stat"><span>Actionable providers</span><strong class="text-emerald">{{ leaActionableCount }}</strong></div>
                            <div class="lea-stat"><span>Compliance directory</span><strong>{{ inv.lea.coverage?.directorySize || 0 }} <small>providers profiled</small></strong></div>
                        </div>

                        <div class="lea-target" *ngFor="let t of inv.lea.targets">
                            <div class="lea-target-head">
                                <div>
                                    <h4>{{ t.service }} <span class="priority-pill" *ngIf="t.priority === 'critical'">Priority 1 — serve first</span></h4>
                                    <p>{{ t.kind }} · {{ t.legalEntity }}</p>
                                </div>
                                <div class="lea-value">
                                    <div>{{ fmtBtc(t.valueNative) }} {{ inv.symbol }}</div>
                                    <div class="muted" *ngIf="t.valueUsd != null">≈ ${{ t.valueUsd | number:'1.0-2' }}</div>
                                </div>
                            </div>
                            <div class="lea-attrs">
                                <div><span>Jurisdiction</span><strong>{{ t.jurisdiction }}</strong></div>
                                <div><span>Regulator</span><strong>Not established</strong></div>
                                <div><span>KYC on file</span><strong>{{ t.kyc }}</strong></div>
                                <div><span>Can freeze funds</span><strong class="text-emerald" *ngIf="t.canFreeze"><i class="fas fa-snowflake"></i> Yes — request immobilisation</strong></div>
                            </div>
                            <div class="legal-box">
                                <div class="legal-box-title">HOW TO SERVE LEGAL PROCESS</div>
                                <p>{{ t.channelLabel }}</p>
                                <a [href]="t.channelValue" target="_blank" rel="noopener">{{ t.channelValue }}</a>
                            </div>
                            <div class="touch-block" *ngIf="t.touchpoints?.length">
                                <div class="legal-box-title">ADDRESSES TO NAME IN THE REQUEST ({{ t.touchpoints.length }})</div>
                                <div class="touch-row" *ngFor="let tp of t.touchpoints">
                                    <button type="button" class="linkish mono" (click)="copyText(tp.address)">{{ tp.address }}</button>
                                    <span class="role-pill">{{ tp.role === 'subject' ? 'subject address' : tp.role }}</span>
                                    <div class="muted small">Basis: {{ tp.basis }}</div>
                                </div>
                            </div>
                            <ul class="note-list">
                                <li *ngFor="let n of t.notes">• {{ n }}</li>
                            </ul>
                            <div class="lea-actions">
                                <button type="button" class="run-trace-btn" (click)="copyText(t.requestDraft)"><i class="fas fa-copy"></i> Copy draft request</button>
                                <button type="button" class="export-outline-btn" (click)="previewDraft = !previewDraft">Preview draft</button>
                            </div>
                            <pre class="draft-preview" *ngIf="previewDraft">{{ t.requestDraft }}</pre>
                        </div>

                        <div class="next-steps" *ngIf="inv.lea.nextSteps?.length">
                            <h4><i class="fas fa-list-ol"></i> Recommended investigative sequence</h4>
                            <ol>
                                <li *ngFor="let step of inv.lea.nextSteps; let i = index"><span class="step-num">{{ i + 1 }}</span>{{ step }}</li>
                            </ol>
                        </div>

                        <div class="unattrib" *ngIf="inv.lea.unattributed?.length">
                            <h4>Highest-value unattributed counterparties</h4>
                            <p class="panel-sub">These moved real money but we could not match them to a known company.</p>
                            <div class="unattrib-row" *ngFor="let u of inv.lea.unattributed">
                                <button type="button" class="linkish mono" (click)="copyText(u.address)">{{ shortAddr(u.address) }}</button>
                                <span class="role-pill danger">{{ u.direction === 'sender' ? 'received from' : 'sent to' }}</span>
                                <strong>{{ fmtBtc(u.amountNative) }} {{ inv.symbol }}</strong>
                            </div>
                        </div>
                    </section>

                    <!-- Risk Factors -->
                    <section class="panel" id="section-risk">
                        <h3 class="panel-title"><i class="fas fa-list-check text-amber"></i> Risk Factor Breakdown</h3>
                        <p class="panel-sub">Why this address got a score of {{ inv.riskScore }} out of 100.</p>
                        <div class="risk-factor" *ngFor="let f of inv.riskFactors">
                            <div class="risk-factor-top">
                                <span>{{ f.label }}</span>
                                <span class="mono" [class.text-emerald]="!f.points" [class.text-amber]="f.points > 0">{{ f.points > 0 ? ('+' + f.points) : '0' }} pts</span>
                            </div>
                            <div class="risk-bar"><div class="risk-bar-fill" [style.width.%]="Math.min(100, f.points || 0)" [class.zero]="!f.points"></div></div>
                            <p class="panel-sub">{{ f.detail }}</p>
                        </div>
                    </section>

                    <!-- Exposure -->
                    <section class="panel" id="section-exposure" *ngIf="inv.exposure">
                        <h3 class="panel-title"><i class="fas fa-crosshairs text-amber"></i> Indirect Exposure</h3>
                        <p class="panel-sub">
                            We followed the money and checked {{ inv.exposure.checkedHop1 }} addresses that dealt directly with this one
                            <ng-container *ngIf="inv.exposure.checkedHop2"> and {{ inv.exposure.checkedHop2 }} more that were one step further away</ng-container>
                            to see if any are linked to sanctions, mixers or known bad addresses.
                        </p>
                        <p class="exposure-ok" *ngIf="!inv.exposure.hits?.length">
                            <i class="fas fa-shield-halved"></i>
                            No exposure to sanctioned entities, mixers, or flagged addresses detected within {{ inv.exposure.maxHops }} hop(s).
                        </p>
                    </section>

                    <!-- Volume chart -->
                    <section class="panel" id="section-chart" *ngIf="volumeChart as vc">
                        <div class="panel-head-row">
                            <h3 class="panel-title">
                                <i class="fas fa-chart-line text-emerald"></i>
                                Transaction Volume Over Time
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('volume', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                        *ngIf="activeInfoHint === 'volume'"
                                        [class.place-top]="infoHintPlacement === 'top'"
                                        [class.place-bottom]="infoHintPlacement === 'bottom'"
                                        [ngStyle]="infoHintStyle"
                                        (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.volume.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.volume.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                        </div>

                        <div class="volume-legend">
                            <span><span class="lg received"></span> Received</span>
                            <span><span class="lg sent"></span> Sent</span>
                        </div>

                        <div class="volume-frame">
                            <div class="volume-y-title">{{ vc.symbol }}</div>
                            <div class="volume-plot">
                                <div class="volume-y-axis" aria-hidden="true">
                                    <span *ngFor="let tick of vc.yTicks">{{ tick }}</span>
                                </div>
                                <div class="volume-plot-area">
                                    <div class="volume-grid" aria-hidden="true">
                                        <span *ngFor="let tick of vc.yTicks"></span>
                                    </div>
                                    <div class="volume-chart">
                                        <div class="volume-col" *ngFor="let bar of vc.bars">
                                            <div class="bars-hit">
                                                <div class="bars">
                                                    <div
                                                        class="bar received"
                                                        [style.height.%]="bar.receivedPct"
                                                        (pointerenter)="showVolumeTooltip(bar, $event)"
                                                        (pointermove)="showVolumeTooltip(bar, $event)"
                                                        (pointerleave)="hideVolumeTooltip()"
                                                    ></div>
                                                    <div
                                                        class="bar sent"
                                                        [style.height.%]="bar.sentPct"
                                                        (pointerenter)="showVolumeTooltip(bar, $event)"
                                                        (pointermove)="showVolumeTooltip(bar, $event)"
                                                        (pointerleave)="hideVolumeTooltip()"
                                                    ></div>
                                                </div>
                                            </div>
                                            <div class="volume-label">{{ bar.label }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="volume-x-title">Month</div>
                        </div>
                    </section>

                    <!-- Shared fixed tooltip (outside overflow clip) -->
                    <div
                        class="volume-tooltip volume-tooltip-fixed"
                        *ngIf="volumeTooltip as tip"
                        [style.left.px]="tip.left"
                        [style.top.px]="tip.top"
                    >
                        <div class="volume-tip-label">{{ tip.label }}</div>
                        <div class="volume-tip-row received">
                            <span class="volume-tip-swatch"></span>
                            Received : {{ fmtVolumeTip(tip.received) }}
                        </div>
                        <div class="volume-tip-row sent">
                            <span class="volume-tip-swatch"></span>
                            Sent : {{ fmtVolumeTip(tip.sent) }}
                        </div>
                    </div>

                    <!-- Narrative -->
                    <section class="panel" id="section-narrative">
                        <div class="panel-head-row">
                            <h3 class="panel-title">
                                <i class="fas fa-file-lines text-emerald"></i>
                                Analyst Narrative
                                <span class="info-hint-wrap">
                                    <button type="button" class="info-hint" (click)="toggleInfoHint('narrative', $event)" aria-label="What does this mean?" title="What does this mean?">?</button>
                                    <div class="info-popover"
                                        *ngIf="activeInfoHint === 'narrative'"
                                        [class.place-top]="infoHintPlacement === 'top'"
                                        [class.place-bottom]="infoHintPlacement === 'bottom'"
                                        [ngStyle]="infoHintStyle"
                                        (click)="$event.stopPropagation()">
                                        <div class="info-popover-block">
                                            <p class="info-popover-label">In simple words</p>
                                            <p class="info-popover-text">{{ kpiHints.narrative.en }}</p>
                                        </div>
                                        <div class="info-popover-block bordered">
                                            <p class="info-popover-label">आसान हिंदी में</p>
                                            <p class="info-popover-text" lang="hi">{{ kpiHints.narrative.hi }}</p>
                                        </div>
                                    </div>
                                </span>
                            </h3>
                        </div>

                        <div class="narrative-block">
                            <div class="narrative-label">In simple words</div>
                            <p>
                                This is a <span class="hl-blue">{{ inv.chainName }}</span> address<span *ngIf="inv.entityLabel?.name"> that looks like it belongs to <span class="hl-blue">{{ inv.entityLabel.name }}</span></span>.
                                Its risk score is <span [ngClass]="narrativeRiskClass">{{ inv.riskScore }} out of 100</span>, which we rate as <span [ngClass]="narrativeRiskClass">{{ inv.riskLevel }}</span>.
                            </p>
                            <p>
                                In total it has received <span class="hl-green">{{ fmtNarrativeBtc(inv.profile?.totalReceived) }} {{ inv.symbol }}</span><ng-container *ngIf="narrativeFiatAbout(inv.usd?.totalReceived, inv.inr?.totalReceived) as recvFiat"> (about <span class="hl-green">{{ recvFiat }}</span>)</ng-container>
                                and sent out <span class="hl-red">{{ fmtNarrativeBtc(inv.profile?.totalSent) }} {{ inv.symbol }}</span>.
                                Right now it holds <span class="hl-green">{{ fmtNarrativeBtc(inv.profile?.balance) }} {{ inv.symbol }}</span><ng-container *ngIf="inv.usd?.balance != null"> (about <span class="hl-green">{{ usdStr(inv.usd?.balance) }}</span>)</ng-container>.
                            </p>
                            <p>
                                It has made <span class="hl-blue">{{ (inv.profile?.txCount || 0) | number }}</span> transaction{{ (inv.profile?.txCount || 0) === 1 ? '' : 's' }} in total.
                                It was first seen on <span class="hl-amber">{{ formatDateTimeClient(effectiveFirstSeen) }}</span>
                                and last active on <span class="hl-amber">{{ formatDateTimeClient(effectiveLastSeen) }}</span>.
                                <ng-container *ngIf="displayTopSenders.length || displayTopReceivers.length">
                                    Its most active senders and receivers are listed in the sections below.
                                </ng-container>
                            </p>
                            <p *ngIf="inv.sanctions?.listed"><span class="hl-red">Warning:</span> this address is on a sanctions or watchlist. Handle with extra care.</p>
                            <p *ngIf="!inv.sanctions?.listed && totalAbuse > 0">
                                People or safety databases have filed <span class="hl-red">{{ totalAbuse }}</span> warning{{ totalAbuse === 1 ? '' : 's' }} against this address. Check the Abuse section for details.
                            </p>
                            <p *ngIf="!inv.sanctions?.listed && totalAbuse === 0">
                                No safety database or user has reported this address — <span class="hl-green">a good sign</span>.
                            </p>
                            <p *ngIf="exposureHitCount > 0">
                                It is also linked to <span class="hl-red">{{ exposureHitCount }}</span> risky address{{ exposureHitCount === 1 ? '' : 'es' }} nearby (sanctioned, mixer, or flagged). See Indirect Exposure.
                            </p>
                        </div>

                        <div class="narrative-block hindi">
                            <div class="narrative-label">आसान हिंदी में</div>
                            <p>
                                यह एक <span class="hl-blue">{{ inv.chainName }}</span> पता है<span *ngIf="inv.entityLabel?.name">, जो शायद <span class="hl-blue">{{ inv.entityLabel.name }}</span> का है</span>।
                                इसका जोखिम स्कोर <span [ngClass]="narrativeRiskClass">100 में से {{ inv.riskScore }}</span> है, जिसे हम <span [ngClass]="narrativeRiskClass">{{ inv.riskLevel }}</span> मानते हैं।
                            </p>
                            <p>
                                अब तक इसे कुल <span class="hl-green">{{ fmtNarrativeBtc(inv.profile?.totalReceived) }} {{ inv.symbol }}</span><ng-container *ngIf="narrativeFiatAbout(inv.usd?.totalReceived, inv.inr?.totalReceived) as recvFiat"> (लगभग <span class="hl-green">{{ recvFiat }}</span>)</ng-container>
                                मिले हैं और इसने <span class="hl-red">{{ fmtNarrativeBtc(inv.profile?.totalSent) }} {{ inv.symbol }}</span> भेजे हैं।
                                अभी इसके पास <span class="hl-green">{{ fmtNarrativeBtc(inv.profile?.balance) }} {{ inv.symbol }}</span><ng-container *ngIf="inv.usd?.balance != null"> (लगभग <span class="hl-green">{{ usdStr(inv.usd?.balance) }}</span>)</ng-container> हैं।
                            </p>
                            <p>
                                इसने कुल <span class="hl-blue">{{ (inv.profile?.txCount || 0) | number }}</span> लेन-देन किए हैं।
                                यह पहली बार <span class="hl-amber">{{ formatDateTimeClient(effectiveFirstSeen) }}</span> को दिखा और आखिरी बार <span class="hl-amber">{{ formatDateTimeClient(effectiveLastSeen) }}</span> को सक्रिय था।
                                <ng-container *ngIf="displayTopSenders.length || displayTopReceivers.length">
                                    इसके सबसे सक्रिय भेजने और पाने वाले नीचे दिए गए सेक्शन में हैं।
                                </ng-container>
                            </p>
                            <p *ngIf="inv.sanctions?.listed"><span class="hl-red">चेतावनी:</span> यह पता sanctions या watchlist पर है। इसे बहुत ध्यान से संभालें।</p>
                            <p *ngIf="!inv.sanctions?.listed && totalAbuse > 0">
                                लोगों या सुरक्षा डेटाबेस ने इस पते के खिलाफ <span class="hl-red">{{ totalAbuse }}</span> चेतावनी दी हैं। विस्तार के लिए Abuse सेक्शन देखें।
                            </p>
                            <p *ngIf="!inv.sanctions?.listed && totalAbuse === 0">
                                किसी सुरक्षा डेटाबेस या यूज़र ने इस पते को रिपोर्ट नहीं किया — <span class="hl-green">यह अच्छी बात है</span>।
                            </p>
                            <p *ngIf="exposureHitCount > 0">
                                यह आस-पास के <span class="hl-red">{{ exposureHitCount }}</span> खराब पतों से भी जुड़ा है (sanctioned, mixer या flagged)। Indirect Exposure देखें।
                            </p>
                        </div>
                    </section>

                    <!-- Notes (kept from OSINT) -->
                    <section class="panel" id="section-notes">
                        <h3 class="panel-title"><i class="fas fa-note-sticky text-amber"></i> Add Notes</h3>
                        <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                        <div class="notes-footer">
                            <span class="character-count">{{ notes.length }}/300</span>
                            <button class="run-trace-btn" (click)="onUpdateNotesButtonClick()">Update Notes</button>
                        </div>
                    </section>
                </ng-container>

                <div class="ai-analysis-view" *ngIf="isOsintAiAnalysisEnabled && !isLoadingResults && selectedSearchResult && activeViewTab === 'ai-analysis'">
                    <app-osint-ai-analysis
                        [searchId]="searchId"
                        type="wallet"
                        [queryValue]="selectedSearchResult?.searched_wallet || displayAddress"
                        [hasSourceData]="true"
                    ></app-osint-ai-analysis>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Community report modal -->
<div class="report-modal-backdrop" *ngIf="reportModalOpen" (click)="closeReportModal()">
    <div class="report-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <div class="report-modal-head">
            <h3><i class="fas fa-flag text-red"></i> Report Address</h3>
            <button type="button" class="icon-btn" (click)="closeReportModal()" [disabled]="reportSubmitting"><i class="fas fa-xmark"></i></button>
        </div>
        <p class="mono muted break-all">{{ displayAddress }}</p>
        <label class="report-label">Category <span class="text-red">*</span></label>
        <select class="depth-select full" [(ngModel)]="reportCategory">
            <option value="" disabled>Select a category…</option>
            <option *ngFor="let c of reportCategories" [ngValue]="c">{{ c }}</option>
        </select>
        <label class="report-label">Note <span class="muted">(optional)</span></label>
        <textarea class="note-input" rows="3" maxlength="1000" placeholder="Add any context that could help other investigators…" [(ngModel)]="reportNote"></textarea>
        <div class="report-modal-actions">
            <button type="button" class="export-outline-btn" (click)="closeReportModal()" [disabled]="reportSubmitting">Cancel</button>
            <button type="button" class="run-trace-btn" (click)="submitCommunityReport()" [disabled]="reportSubmitting || !reportCategory">
                {{ reportSubmitting ? 'Submitting…' : 'Submit report' }}
            </button>
        </div>
    </div>
</div>

<!-- KPI detail drawer -->
<div class="detail-drawer-backdrop" *ngIf="detailDrawer" (click)="closeDetailDrawer()"></div>
<aside
    class="detail-drawer"
    *ngIf="detailDrawer"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="detailDrawerTitle"
    (click)="$event.stopPropagation()"
>
    <div class="detail-drawer-head">
        <h3>
            <i class="fas" [ngClass]="[detailDrawerIcon, detailDrawerIconClass]"></i>
            {{ detailDrawerTitle }}
        </h3>
        <button type="button" class="icon-btn" (click)="closeDetailDrawer()" aria-label="Close panel">
            <i class="fas fa-xmark"></i>
        </button>
    </div>
    <div class="detail-drawer-body">
        <ng-container *ngIf="detailDrawer === 'received'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">Total received ({{ inv.symbol }})</span>
                <span class="drawer-stat-value accent-amber">{{ fmtBtc(inv.profile?.totalReceived) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In USD</span>
                <span class="drawer-stat-value accent-emerald">{{ usdStr(inv.usd?.totalReceived) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In INR</span>
                <span class="drawer-stat-value accent-emerald">{{ inrStr(inv.inr?.totalReceived) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Transactions on record</span>
                <span class="drawer-stat-value">{{ (inv.profile?.txCount || 0) | number }}</span>
            </div>
            <p class="drawer-section-label">Where funds came from</p>
            <div class="drawer-cp-list" *ngIf="displayTopSenders.length; else noSenders">
                <div class="drawer-cp" *ngFor="let cp of displayTopSenders">
                    <div class="drawer-cp-meta">
                        <span class="drawer-cp-label" *ngIf="cp.label?.name">{{ cp.label.name }} · {{ cp.label.type }}</span>
                        <span class="drawer-cp-amt">{{ fmtBtc(cp.totalBtc) }} {{ inv.symbol }}</span>
                        <span class="drawer-cp-tx">{{ cp.txCount || 0 }} tx</span>
                    </div>
                    <button type="button" class="drawer-cp-addr" (click)="investigateAddress(cp.address)" [title]="cp.address">
                        {{ cp.address }}
                    </button>
                </div>
            </div>
            <ng-template #noSenders>
                <p class="drawer-muted">No sender detail available in the fetched window.</p>
            </ng-template>
            <p class="drawer-note" *ngIf="displayNote">{{ displayNote }}</p>
        </ng-container>

        <ng-container *ngIf="detailDrawer === 'sent'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">Total sent ({{ inv.symbol }})</span>
                <span class="drawer-stat-value accent-red">{{ fmtBtc(inv.profile?.totalSent) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In USD</span>
                <span class="drawer-stat-value accent-emerald">{{ usdStr(inv.usd?.totalSent) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In INR</span>
                <span class="drawer-stat-value accent-emerald">{{ inrStr(inv.inr?.totalSent) }}</span>
            </div>
            <p class="drawer-section-label">Where funds went</p>
            <div class="drawer-cp-list" *ngIf="displayTopReceivers.length; else noReceivers">
                <div class="drawer-cp" *ngFor="let cp of displayTopReceivers">
                    <div class="drawer-cp-meta">
                        <span class="drawer-cp-label" *ngIf="cp.label?.name">{{ cp.label.name }} · {{ cp.label.type }}</span>
                        <span class="drawer-cp-amt">{{ fmtBtc(cp.totalBtc) }} {{ inv.symbol }}</span>
                        <span class="drawer-cp-tx">{{ cp.txCount || 0 }} tx</span>
                    </div>
                    <button type="button" class="drawer-cp-addr" (click)="investigateAddress(cp.address)" [title]="cp.address">
                        {{ cp.address }}
                    </button>
                </div>
            </div>
            <ng-template #noReceivers>
                <p class="drawer-muted">No receiver detail available in the fetched window.</p>
            </ng-template>
            <p class="drawer-note" *ngIf="displayNote">{{ displayNote }}</p>
        </ng-container>

        <ng-container *ngIf="detailDrawer === 'balance'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">Current balance ({{ inv.symbol }})</span>
                <span class="drawer-stat-value accent-emerald">{{ fmtBtc(inv.profile?.balance) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In USD</span>
                <span class="drawer-stat-value accent-emerald">{{ usdStr(inv.usd?.balance) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In INR</span>
                <span class="drawer-stat-value accent-emerald">{{ inrStr(inv.inr?.balance) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Live price ({{ inv.symbol }})</span>
                <span class="drawer-stat-value accent-amber">{{ fiatPair(inv.usd?.price, inv.inr?.price) }}</span>
            </div>
            <p class="drawer-section-label">Address</p>
            <p class="drawer-addr-box mono">{{ displayAddress }}</p>
            <button type="button" class="drawer-copy-btn" (click)="copyText(displayAddress)">Copy address</button>
            <p class="drawer-note">Balance is queried live from the blockchain and is exact.</p>
        </ng-container>

        <ng-container *ngIf="detailDrawer === 'transactions'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">Total transactions</span>
                <span class="drawer-stat-value accent-blue">{{ (inv.profile?.txCount || 0) | number }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">{{ fullHistory ? 'Incoming (full history)' : 'Incoming (all time)' }}</span>
                <span class="drawer-stat-value accent-emerald">
                    <ng-container *ngIf="fullHistory; else inAllTime">
                        {{ fullHistory.inCount | number }} txs · {{ fmtBtc(fullHistory.inVolume) }} {{ inv.symbol }}
                    </ng-container>
                    <ng-template #inAllTime>{{ fmtBtc(inv.profile?.totalReceived) }} {{ inv.symbol }}</ng-template>
                </span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">{{ fullHistory ? 'Outgoing (full history)' : 'Outgoing (all time)' }}</span>
                <span class="drawer-stat-value accent-red">
                    <ng-container *ngIf="fullHistory; else outAllTime">
                        {{ fullHistory.outCount | number }} txs · {{ fmtBtc(fullHistory.outVolume) }} {{ inv.symbol }}
                    </ng-container>
                    <ng-template #outAllTime>{{ fmtBtc(inv.profile?.totalSent) }} {{ inv.symbol }}</ng-template>
                </span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">In the loaded rows</span>
                <span class="drawer-stat-value">{{ txInCount }} in · {{ txOutCount }} out</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Detail rows loaded</span>
                <span class="drawer-stat-value">{{ (inv.transactions?.length || 0) | number }}</span>
            </div>
            <p class="drawer-muted mt">
                The timeline and volume chart below the KPIs visualise the most recent transactions loaded in detail
                (the rows counted above), each with its USD/INR value at the time of the transfer.
            </p>
            <p class="drawer-note" *ngIf="displayNote">{{ displayNote }}</p>
        </ng-container>

        <ng-container *ngIf="detailDrawer === 'activity'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">First seen</span>
                <span class="drawer-stat-value accent-purple">{{ formatDateTimeClient(effectiveFirstSeen) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Last seen</span>
                <span class="drawer-stat-value accent-cyan">{{ formatDateTimeClient(effectiveLastSeen) }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Address age</span>
                <span class="drawer-stat-value accent-amber">{{ effectiveAddressAge }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Days since last activity</span>
                <span class="drawer-stat-value">
                    {{ daysSinceLastActivity != null ? (daysSinceLastActivity | number) + ' day(s)' : '—' }}
                </span>
            </div>
            <p class="drawer-muted mt">
                Dormancy and address age both feed into the risk score. A long-dormant address that suddenly reactivates is a
                common laundering signal.
            </p>
        </ng-container>

        <ng-container *ngIf="detailDrawer === 'abuse'">
            <div class="drawer-stat">
                <span class="drawer-stat-label">Total findings</span>
                <span class="drawer-stat-value" [class.accent-red]="totalAbuse > 0" [class.accent-emerald]="totalAbuse === 0">{{ totalAbuse }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">External abuse reports</span>
                <span class="drawer-stat-value" [class.accent-red]="(inv.abuseCount || 0) > 0" [class.accent-emerald]="!(inv.abuseCount > 0)">{{ inv.abuseCount || 0 }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Threat-intel flags</span>
                <span class="drawer-stat-value" [class.accent-red]="(inv.threatFlags?.length || 0) > 0" [class.accent-emerald]="!(inv.threatFlags?.length > 0)">{{ inv.threatFlags?.length || 0 }}</span>
            </div>
            <div class="drawer-stat">
                <span class="drawer-stat-label">Community reports</span>
                <span class="drawer-stat-value" [class.accent-amber]="(inv.communityReportCount || 0) > 0" [class.accent-emerald]="!(inv.communityReportCount > 0)">{{ inv.communityReportCount || 0 }}</span>
            </div>
            <div *ngIf="inv.threatFlags?.length">
                <p class="drawer-section-label">Threat flags</p>
                <div class="drawer-flag-row">
                    <span class="drawer-flag" *ngFor="let f of inv.threatFlags">⚠ {{ f }}</span>
                </div>
            </div>
            <p class="drawer-section-label">By platform</p>
            <div class="drawer-platform-list">
                <div class="drawer-platform" *ngFor="let s of abuseSources">
                    <span class="drawer-platform-name">{{ s.source }}</span>
                    <span
                        *ngIf="s.status === 'ok'"
                        class="drawer-platform-count"
                        [class.accent-red]="(s.count || 0) > 0"
                        [class.accent-emerald]="!(s.count > 0)"
                    >{{ s.count || 0 }}</span>
                    <span *ngIf="s.status !== 'ok'" class="drawer-muted">-</span>
                </div>
            </div>
        </ng-container>
    </div>
</aside>
